import { render, staticRenderFns } from "./PsinEditAppr.vue?vue&type=template&id=60750e5d&scoped=true&"
import script from "./PsinEditAppr.vue?vue&type=script&lang=js&"
export * from "./PsinEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60750e5d",
  null
  
)

export default component.exports